"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const SvgUserAdd = (props) => (React.createElement("span", { className: "anticon" },
    React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", className: "PayPing-icon" }, props),
        React.createElement("path", { d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
        React.createElement("circle", { cx: 8.5, cy: 7, r: 4 }),
        React.createElement("line", { x1: 20, y1: 8, x2: 20, y2: 14 }),
        React.createElement("line", { x1: 23, y1: 11, x2: 17, y2: 11 }))));
exports.default = SvgUserAdd;
//# sourceMappingURL=UserAdd.js.map